export default [

	{
		name1: '<br>Лагерь выживших в лесу',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Небольшой палаточный лагерь в лесу близ разрушенной Атланты. Некоторое время служил убежищем для главных героев в первом сезоне, пока зомби из города не стали все чаще покидать город в поисках пищи в лесу.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Здесь жила семья Рика, его напарник Шейн, Гленн, Дейл, Дэрил, сестры Андреа и Эми, семья Моралес, Ти-Дог и еще десяток людей из первого сезона.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Свежий воздух, неподалеку пруд с рыбой. Всегда можно устроить вылазку в город, где все еще можно найти запасы провизии. Самое безопасное место в лагере — на крыше трейлера.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Нет ограждений и прочих средств защиты от внезапного нападения зомби, кроме растянутой лески с колокольчиками. В немалой степени по этим причинам лагерь был покинут героями в конце первого сезона.
			</div>
		`
	},

	{
		name1: '<br>Ферма Хершела Грина',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Большой дом с сараем и приусадебным участком в сельской местности штата Джорджия. Практически все события второго сезона развиваются на ферме.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Фермер Хершел Грин, его старшая дочь Мэгги, еще несколько его дочерей и сыновей, сосед Отис. Во втором сезоне на ферму переселилась группа Рика.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Крыша над головой, фермерский уют американского Юга, удаленность от эпицентра эпидемии, небольшие запасы и фермер Хершел с навыками ветеринара, которые пригодятся в случае хирургического вмешательства.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				В сарае спрятана от чужих глаз толпа голодных зомби, среди которых есть родственники Хершела, потому что старик отказывается верить в то, что они мертвы.
			</div>
		`
	},

	{
		name1: '<br>Тюрьма',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Исправительное учреждение западной Джорджии, сильно пострадавшее во время зомби-апокалипсиса, но в отдельных изолированных блоках еще скрывались выжившие.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Выжившие заключенные, затем тюрьму заселяет группа Рика.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				После зачистки от зомби всей территории тюрьма стала надежным убежищем, полностью защищенным высоким проволочным забором. Внутри комплекса были достаточные запасы продуктов, чтобы прожить длительное время. Со временем на территории стали выращивать свиней и высаживать огород.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Огромная территория — слишком лакомый кусок для воинствующих конкурентов. Кроме того, в тюрьме стала быстро распространяться инфекция. В итоге тюрьму разрушили подчиненные Губернатора и орды зомби.
			</div>
		`
	},

	{
		name1: '<br>Вудбери',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Хорошо охраняемый небольшой городок в штате Джорджия.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Более чем полсотни выживших людей во главе с авторитарным лидером по прозвищу Губернатор. Долгое время городок был спокойным местом, где все счастливо жили, подчиняясь строгому распорядку, включавшему комендантский час в темное время суток.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Реальное чувство защищенности — за зиму жители Вудбери не потеряли ни одного человека. Городские развлечения — у них были свои бары, рестораны, а для разрядки по вечерам устраивали бои с зомби.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Лидер-самодур с психическими расстройствами, который готов пойти на все ради своей выгоды. Он лгал жителям города, не пренебрегал пытками и манипуляциями. В итоге Вудбери пал в войне с группой Рика, и Губернатор сжег город.
			</div>
		`
	},

	{
		name1: '<br>Терминус',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Община близ железнодорожных путей в Атланте, которую можно найти по специальным плакатам, расставленным вдоль дорог.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Группа выживших, которые пережили нападение банды насильников и мародеров, из-за чего озлобились и стали каннибалами, руководствуясь принципом «Ты или мясник, или скот».
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Сытные обеды с большими кусками мяса на гриле.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Каннибализм все-таки.
			</div>
		`
	},

	{
		name1: '<br>Мемориальный госпиталь Грейди',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Больница в центре Атланты, подконтрольная полицейскому спецназу и военным.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Доктора и полицейские, поддерживающие суровые правила для всех пациентов, которых привозят в больницу: если больному не становится лучше, то его лишают жизни, дабы не тратить ресурсы; если человек идет на поправку, то он должен отплатить чем-то персоналу: добыть припасы или отработать в качестве обслуги.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Медицинское обслуживание.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Платное медицинское обслуживание. Как правило, женщин просят расплатиться натурой. Первый этаж заполонен ходячими мертвецами. Туда сбрасывают тела больных, которые не идут на поправку или не соглашаются быть благодарными.
			</div>
		`
	},

	{
		name1: '<br>Александрия',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Укрепленный город в окрестностях Вашингтона на месте экспериментального экопоселения, которое после апокалипсиса военные превратили в важный форпост для выживания большого количества людей.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Около полусотни не слишком дельных и волевых людей под управлением чересчур демократичной конгрессменши, которая как раз искала суровых помощников для управления городом и нашла их в лице группы Рика.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Безопасная зона с автономной электростанцией и системой сбора и фильтрации воды. У жителей полно оружия.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Профессиональный уровень подготовки александрийцев настолько низкий, что с ними каши не сваришь. Из-за этого городок оказался в лапах Спасителей.
			</div>
		`
	},

	{
		name1: '<br>Убежище',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Основная база Спасителей в штате Вашингтон.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Головорезы во главе со свирепым и харизматичным лидером по имени Ниган, которому все безоговорочно подчиняются. Все члены банды даже называют себя Ниганом, подчеркивая свою верность одному человеку. Банды Спасителей грабят и захватывают все ближайшие поселения.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Разветвленная сеть подчиненных, которые исправно добывают припасы, поэтому Спасители не отказывают себе ни в чем.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Воровская жизнь и безумный лидер, который не щадит никого.
			</div>
		`
	},

	{
		name1: '<br>Свалка',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Убежище на свалке по соседству с Александрией.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Группа выживших, которых называют Мусорщиками из-за места обитания. Лидером общины значится женщина по имени Джедис.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				У них есть солнечные электростанции и контейнеры, которые используются как жилые комнаты.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Не самое приятное место для жительства. Всем вновь прибывшим в общину нужно доказать свою состоятельность в боевой яме против огромного зомби в шипованном шлеме. Постоянно приходится платить оброк Спасителям, чтобы они не нападали.
			</div>
		`
	},

	{
		name1: '<br>Хиллтоп',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Колония в здании краеведческого музея неподалеку от Вашингтона, обнесенная деревянными бревенчатыми стенами.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Разведчик по кличке Иисус, тяжело пьющий лидер общины Грегори, множество семей и детей, которые родились уже прямо в колонии. Жители занимаются сельским хозяйством и металлообработкой, используя бывшие экспонаты музея.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Расположенность на холме, что дает хороший обзор окрестностей. Своя система водопровода. Свой кузнец.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Уклад застрял на уровне XVIII–XIX веков. В колонии практически нет огнестрельного оружия — люди используют арбалеты и копья.
			</div>
		`
	},

	{
		name1: '<br>Королевство',
		text: `
			<div class="title">Где находится</div>
			<div class="text">
				Поселение на территории бывшей школы в окрестностях Вашингтона.
			</div>
			<div class="title">Кто жил (или живет)</div>
			<div class="text">
				Большая община во главе с лидером, который называет себя королем Иезекиилем и водит на поводке ручную тигрицу Шиву. Уклад поселения можно назвать почти социалистическим: все занимаются коллективным трудом, стараются приносить пользу и уважать своего короля.
			</div>
			<div class="title">Преимущества</div>
			<div class="text">
				Ручная тигрица. Библиотеки, кружки, есть даже поющий хор. Единственная община, которая использует лошадей в боевых целях: город защищают всадники в своеобразных доспехах, сделанных из футбольной защиты.
			</div>
			<div class="title">Недостатки</div>
			<div class="text">
				Придется снова ходить в школу и питаться в столовой. К тому же школа не производит впечатления надежного места для жительства.
			</div>
		`
	},


]



// WEBPACK FOOTER //
// ./src/data/slider8.js